import React from 'react';
function TravelSafeLogo(props) {
	const { gradientId, ...otherProps } = props;
	return (
		<svg viewBox='0 0 74 74' {...otherProps}>
			<defs>
				<linearGradient id={gradientId} x1='50%' x2='50%' y1='-6.44%' y2='113.78%'>
					<stop offset='0%' stop-color='#89D500' />
					<stop offset='100%' stop-color='#43A200' />
				</linearGradient>
			</defs>
			<g fill='none' fill-rule='evenodd'>
				<circle cx='37' cy='37' r='37' fill={`url(#${gradientId})`} />
				<path
					fill='#FFF'
					d='M54.5218813 20.3086159l.0874479.0833869c1.1875611 1.1810225 1.1875611 3.0448212 0 4.2258437l-8.8282189 8.7770743 5.598507 15.0110807c.1133295.3038764.0654019.6369721-.1198071.8979353l-.1274074.1471112-3.4840679 3.3222729-8.3260814-12.9547563-8.3958827 8.3489319 1.5681762 3.7261752c.1342104.3193399.0861719.6777209-.1177221.9523241l-.1148128.1297515L29.614828 55.5l-3.9554452-5.8478711-6.131605-3.7707509 2.6471841-2.5242527c.2976314-.2838099.7440658-.3710438 1.1347728-.2217363l3.019091 1.1534541 8.7344943-8.6858574-14.0048425-8.1847273 3.4840679-3.3222728c.286995-.2736674.7135302-.3654141 1.0959404-.2357342l15.8332147 5.3692282 8.888389-8.8374768c1.125099-1.1189044 2.9883967-1.1562379 4.1617918-.0833869z'
				/>
			</g>
		</svg>
	);
}

TravelSafeLogo.defaultProps={
  gradientId: 'travelsafe-gradient'
}

export default TravelSafeLogo